import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.title-non-final',
		defaultMessage: 'Shift your work from Opsgenie to Jira',
		description: 'Title of step one for optimal tooling wizard',
	},
	descriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.description-non-final',
		defaultMessage:
			'Make Jira Service Management your team’s central place to do all the operations work that they do with Opsgenie.',
		description: 'Description of step one for optimal tooling wizard',
	},
	alertsTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.alerts-title-non-final',
		defaultMessage: 'Respond to alerts',
		description: 'Title of alerts section for optimal tooling wizard',
	},
	alertsDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.alerts-description-non-final',
		defaultMessage:
			'Access all your alerts natively from Jira Service Management’s Your work page.',
		description: 'Description of alerts section for optimal tooling wizard',
	},
	operationsTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.operations-title-non-final',
		defaultMessage: 'Manage operations',
		description: 'Title of operations section for optimal tooling wizard',
	},
	operationsDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.operations-description-non-final',
		defaultMessage:
			'Find your integrations, custom roles, maintenance, notifications, policies, audit logs, and more in Jira settings.',
		description: 'Description of alerts section for optimal tooling wizard',
	},
	mobileTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.mobile-title-non-final',
		defaultMessage: 'Get mobile notifications',
		description: 'Title of mobile section for optimal tooling wizard',
	},
	mobileDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.mobile-description-non-final',
		defaultMessage:
			'Stay notified of alerts, check on-call schedules, and manage notification rules on the go with Jira Cloud mobile.',
		description: 'Description of mobile notifications section for optimal tooling wizard',
	},
	teamsTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.teams-title-non-final',
		defaultMessage: 'Build efficient on-call teams',
		description: 'Title of teams section for optimal tooling wizard',
	},
	teamsDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.teams-description-non-final',
		defaultMessage:
			'Your Opsgenie teams will become Atlassian teams, so you can manage all your teams, including on-call, from Jira.',
		description: 'Description of teams section for optimal tooling wizard',
	},
	incidentsTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.incidents-title-non-final',
		defaultMessage: 'Streamlined incident management',
		description: 'Title of incidents section for optimal tooling wizard',
	},
	incidentsDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.one.incidents-description-non-final',
		defaultMessage: 'Detect and resolve incidents collaboratively in Jira Service Management.',
		description: 'Description of incidents section for optimal tooling wizard',
	},
});
